var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcForums(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M753 167c67 0 121 54 121 120v363h1v183c0 23-18 41-40 41-11 0-21-5-29-13l-89-90H246c-67 0-121-54-121-121V287c0-66 54-120 121-120h507zM302 408c-32 0-59 27-59 61 0 33 27 60 59 60 33 0 60-27 60-60 0-34-27-61-60-61zm198 0c-33 0-60 27-60 61 0 33 27 60 60 60 32 0 59-27 59-60 0-34-27-61-59-61zm197 0c-33 0-59 27-59 61 0 33 26 60 59 60 32 0 59-27 59-60 0-34-27-61-59-61z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcForums);
export default __webpack_public_path__ + "static/media/ic_forums.1b3cbddf91b4aadb395dfaa98719acd1.svg";
export { ForwardRef as ReactComponent };